
{
  "text": {
    "label": "Message",
    "placeholder": "Aa"
  }
}
